export const ACTIVITY_TYPES = [
  'INBOUND_CALL',
  'OUTBOUND_CALL',
  'INBOUND_SMS',
  'OUTBOUND_SMS',
  'TEAM_MEMBER_ADDED',
  'TEAM_MEMBER_REMOVED',
  'COMPANY_UPDATED',
  'COMPANY_PHONE_NUMBER_ASSIGN',
] as const;

export type ActivityType = (typeof ACTIVITY_TYPES)[number];

/**
 * Mapping of activity type values that should expand to multiple server values.
 * When a value needs to match multiple backend event types, use the `in` operator
 * with comma-separated values.
 */
export const ACTIVITY_TYPE_EXPANSION: Record<string, string[]> = {
  COMPANY_UPDATED: ['COMPANY_UPDATED', 'COMPANY_UPDATED_FROM_INTEGRATION'],
};

export const ACTIVITY_CONDITIONS = [
  { value: 'from', labelKey: 'from', serverField: 'event_user_account' },
  { value: 'is', labelKey: 'is', serverField: 'event_type' },
] as const;

export type ActivityCondition = (typeof ACTIVITY_CONDITIONS)[number]['value'];
